import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey(
  '1ce20755f8c7b59110b4f43b3934f617Tz03Mjc0NixFPTE3MjM3NDE4MzkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
)

export default LicenseInfo
